//import fs from 'node:fs';
//import * as fs from 'fs';

//                      
// Markdown parser.     
// Generates a AST for the markdown in JSON.
// This JSON can then be used to generate the actual HTML
//                 

const Tdebug = false;
                                
export class MarkdownParser {  

    // Note: This takes the file name and parses the markdown.
    constructor(fileName) {
                    
            // These are used as globals.
            // The parser first behaves like a Lexer. It analyzes the markdown
            // character by character and advances the variable 'position' below.
            this.position = 0;
                    
            // This is the actual markdown text initialized in the below
            // variable.
            this.markdown = '';

            // The file passed for markdown.
            this.file = fileName || '';

    }               

    // This function acts like a constructor where data is initialized and the
    // process of parsing is initiated.
    parse(markdown) {

        Tdebug && console.log("Starting the parser process");
        

        // If the file is passed, use that file's contents
        if (this.file !== '') {
            try {

                    //const dataFile = require(this.file);
                    const dataFile = require('../pages/Blogs/Markdown/wix_vs_wordpress.md')
                    Tdebug && console.log(dataFile);

                    /*
                    const data = fs.readFileSync(this.file, 'utf8');
                    Tdebug && console.log(data);
                    */

                    Tdebug && console.log("Reading the file " + this.file);
                    Tdebug && console.log("Fetching the data from file " + dataFile);

                    //fetch(this.file)
                    fetch(dataFile)
                    .then(r => r.text())
                    .then(data => {
                        Tdebug && console.log(data);
                        this.markdown = data;

                        Tdebug && console.log("File is now read");
                        Tdebug && console.log(data);

                        this.markdown = data;
                        Tdebug && console.log(this.markdown);

                        return this.parseBlock();
                    })
                .catch((err) => {
                    Tdebug && console.log(err);
                })
                
                

                /*
                Tdebug && console.log(data);
                this.markdown = data;
                */

                // const ast = this.parse(data);
                // Tdebug && console.log(JSON.stringify(ast, null, 2));

            } catch (err) {
                console.error(err);

                // Return empty JSON
                return {};
            }

        }
        else {

            this.markdown = markdown;
        }
        
        this.position = 0;
        Tdebug && console.log(this.markdown);

        if (this.markdown == '') {
            return {};
        }

        return this.parseBlock();
    }

    // Parse the entire markdown. This is the entrypoint of the parser
    parseBlock() {  
        const nodes = [];
                
        while (this.position < this.markdown.length) {
                const char = this.markdown[this.position];

                if (char === '\n') {
                    nodes.push(this.parseNewLine());
                    continue;
            }

            if (char === '#') {
                    nodes.push(this.parseHeader());
                    continue;
            }

            if (char === '-' || char === '*' || (char >= '0' && char <= '9')) {
                    nodes.push(this.parseList());
                    continue;
            }

            nodes.push(this.parseParagraph());
        }

        return {
                type: 'document',
                children: nodes
        };
    }

    // Parse a new line character.
    parseNewLine() {

        // We have already reached this position and have encountered a newline.
        // Hence we are to just return the appropriate JSON for the newline
        // character.
        this.position++;
        return {
                type: 'newLine',
                value: ''
        };
    }

    // A '#' was encountered. Parse this heading
    parseHeader() {

            // Level indicates h1, h2, ...
            let level = 0;

            // If we encounter one or more consecutive '#', keep increasing the levels of the
            // Heading.
            while (this.position < this.markdown.length && this.markdown[this.position] === '#') {
                    level++;
                    this.position++;
            }

            // Ignore white space.
            while (this.position < this.markdown.length && this.markdown[this.position] === ' ') {
                    this.position++;
            }

            // Once all the 'headings' and 'whitespaces' are done, whats left is the actual text of
            // the heading.
            const content = this.parseInline();

            return {
                    type: 'heading',
                    level,
                    children: content
            };
    }

    // Parse the list.
    parseList() {
        const items = [];
        let isOrdered = false;

        // If the list starts with a digit, then its an ordered list.
        if (this.markdown[this.position] >= '0' && this.markdown[this.position] <= '9') {
                isOrdered = true;
        }

        while (this.position < this.markdown.length) {
            for (let ll = this.position; ll < this.position + 10; ll++) {
                Tdebug && console.log(this.markdown[ll]);
            }

            if (isOrdered) {

                // Advance till we have no whitespaces.
                while (this.position < this.markdown.length &&
                        (this.markdown[this.position] >= '0' && this.markdown[this.position] <= '9' ||
                        this.markdown[this.position] === '.' ||
                        this.markdown[this.position] === ' ')
                ) {
                        this.position++;
                }
            } else {
                this.position++;

                // Advance till we have no whitespaces.
                while (this.position < this.markdown.length && this.markdown[this.position] === ' ') {
                        this.position++;
                }
            }


            // The whitespace after the digit, star or dash has ended. This is the actual item
            // or content of the list.
            const content = this.parseInline();
            items.push({
                type: 'listItem',
                children: content
            });

            Tdebug && console.log(content);
            Tdebug && console.log("List object so far is: " + JSON.stringify(items));

            for (let ll = this.position; ll < this.position + 10; ll++) {
                Tdebug && console.log(this.markdown[ll]);
            }

            // The content has ended, this has to be a next line after this.
            // The parseInline has already crossed the newline character. Hence no need of the below
            let nextLineStart = this.position;

            /*
            while (nextLineStart < this.markdown.length && this.markdown[nextLineStart] !== '\n') {
                nextLineStart++;
            }

            // This is the actual newline character, advance past this.
            nextLineStart++;
            */


            Tdebug && console.log("Next line's first char is: " + this.markdown[nextLineStart]);
            Tdebug && console.log("Next line's second char is:  " + this.markdown[nextLineStart+1]);
            Tdebug && console.log("Next line's third char is: " + this.markdown[nextLineStart+2]);

            // Have we reached the end of the file, if not, are any of the follwing conditions true:
            // The next line is not one of the ordered or unordered list. In this case, the list has
            // ended. Break out.
            if (nextLineStart >= this.markdown.length ||
                (this.markdown[nextLineStart] !== '-' &&
                    this.markdown[nextLineStart] !== '*' &&
                    !(this.markdown[nextLineStart] >= '0' && this.markdown[nextLineStart] <= '9'))) {
                    break;
                }

            // The next character is one of the ordered or unordered list characters. Hence, get the
            // next item of the list.

        }

        return {
                type: isOrdered ? 'orderedList' : 'unorderedList',
                children: items
        };
    }

    // Parse the paragraph.
    parseParagraph() {
        const content = this.parseInline();

        return {
                type: 'paragraph',
                children: content
        };
    }

    // Parse what exists inside another markdown feature, eg. list inside a heading,
    // Or Lists inside Lists.
    parseInline() {
        const nodes = [];
        let text = '';

        // Continue processing until we encounter a new line.
        while (this.position < this.markdown.length && this.markdown[this.position] !== '\n') {
            const char = this.markdown[this.position];

            // Parse links
            if (char === '[') {
                if (text) {
                        nodes.push({ type: 'text', value: text });
                        text = '';
                }
                nodes.push(this.parseLink());
                continue;
            }

            // Parse bold text. If this character and the next character are both '*', then its
            // Bold text.
            if (char === '*' && this.markdown[this.position + 1] === '*') {
                if (text) {
                        nodes.push({ type: 'text', value: text });
                        text = '';
                }

                // Skip the first two '**' of the bold marker and proceed.
                this.position += 2;
                const content = this.parseBold();

                nodes.push({
                        type: 'bold',
                        children: content
                });

                continue;
            }


            // Parse italic text
            if (char === '_') {
                if (text) {
                        nodes.push({ type: 'text', value: text });
                        text = '';
                }

                this.position++;
                const content = this.parseItalic();

                nodes.push({
                        type: 'italic',
                        children: content
                });

                continue;
            }

            // Support for code block, i.e. " ``` "
            // Parse code blocks with triple backticks
            if (char === '`' &&
                this.position + 2 < this.markdown.length &&
                this.markdown[this.position + 1] === '`' &&
                this.markdown[this.position + 2] === '`') {

                if (text) {
                        nodes.push({ type: 'text', value: text });
                        text = '';
                }

                this.position += 3; // Skip triple backticks
                const { code, language } = this.parseCodeBlock();

                nodes.push({
                    type: 'codeBlock',
                    value: code,
                    language: language
                });

                continue;
            }

            // Parse code
            if (char === '`') {
                if (text) {
                        nodes.push({ type: 'text', value: text });
                        text = '';
                }

                this.position++;
                const content = this.parseCode();

                nodes.push({
                        type: 'code',
                        value: content
                });

                continue;
            }

                text += char;
                this.position++;
        } // While loop for a new line

        if (text) {
                Tdebug && console.log(text);
                nodes.push({ type: 'text', value: text });
        }

        if (this.position < this.markdown.length && this.markdown[this.position] === '\n') {
            this.position++;

        }

        return nodes;
    } 

    // Parse Link
    parseLink() {
        this.position++; // Skip [
        let linkText = '';

        // Parse link text
        while (this.position < this.markdown.length && this.markdown[this.position] !== ']') {
            linkText += this.markdown[this.position];
            this.position++;
        }

        this.position++; // Skip ]

        let url = '';
    
        if (this.position < this.markdown.length && this.markdown[this.position] === '(') {
            this.position++; // Skip (

            // Parse URL
            while (this.position < this.markdown.length && this.markdown[this.position] !== ')') {
                url += this.markdown[this.position];                    
                this.position++;
            }

            this.position++; // Skip )
        }

        return {
            type: 'link',
            text: linkText,
            url: url
        };
    }
    
    // Parse Bold text.
    parseBold() {
        const nodes = [];
        let text = '';

        while (this.position < this.markdown.length) {

            // If we have reached the two end markers '**', then we are done.
            // If not, keep adding the text to the text variable.
            // This means we don't currently support any inline italics, or any
            // other element nested inside bold.
            if (this.markdown[this.position] === '*' && this.markdown[this.position + 1] === '*') {
                if (text) {
                        nodes.push({ type: 'text', value: text });
                }
                this.position += 2;
                return nodes;
            }

            text += this.markdown[this.position];
            this.position++;
        }

        return nodes;
    }
    
    // Parse Italic text
    parseItalic() {
        const nodes = [];
        let text = '';

        while (this.position < this.markdown.length) {
            // If we have reached the end marker '_', then we are done.
            // If not, keep adding the text to the text variable.
            // This means we don't currently support any inline bold, or any
            // other element nested inside italics.
            if (this.markdown[this.position] === '_') {
                if (text) {
                    nodes.push({ type: 'text', value: text });
                }

                this.position++;
                return nodes;
            }

            text += this.markdown[this.position];
            this.position++;
        }

        return nodes;
    }

    // Parse a code block.
    parseCodeBlock() {
        let language = '';
        let code = '';

        // Parse language identifier if present
        while (this.position < this.markdown.length && this.markdown[this.position] !== '\n') {
                language += this.markdown[this.position];
                this.position++;
        }

        this.position++; // Skip newline

        // Parse code content until closing triple backticks
        while (this.position < this.markdown.length) {
            if (this.markdown[this.position] === '`' &&
                this.position + 2 < this.markdown.length &&
                this.markdown[this.position + 1] === '`' &&
                this.markdown[this.position + 2] === '`') {

                    this.position += 3; // Skip closing triple backticks
                    break;
            }

            code += this.markdown[this.position];
            this.position++;
        }

        return {
            code: code.trim(),
            language: language.trim()
        };
    }


    // Prase code
    parseCode() {
        let code = '';

        while (this.position < this.markdown.length && this.markdown[this.position] !== '`') {
                code += this.markdown[this.position];
                this.position++;
        }

        if (this.position < this.markdown.length) {
                this.position++;
        }

        return code;
    }
} // Parser end

/*
// Execution begins here if directly testing with the file. //

// Test with your example
const parser = new MarkdownParser();
const markdown = `On the other hand, a single-page application (SPA), like a [React](https://react.dev/) app, is a type of web application that dynamically updates content without requiring a full page reload.`;

const ast = parser.parse(markdown);
Tdebug && console.log(JSON.stringify(ast, null, 2));

try {
        //const data = fs.readFileSync('blog.md', 'utf8');
        const data = fs.readFileSync('wix-vs-wordpress.md.v2.modified', 'utf8');
        Tdebug && console.log(data);

        const ast = parser.parse(data);
        Tdebug && console.log(JSON.stringify(ast, null, 2));
} catch (err) {
        console.error(err);
}
  */  